import { AuthError } from 'firebase/auth';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isAuthError(error: any | unknown): error is AuthError {
    return error.code && error.message;
}
